/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { ConversationParticipant } from '@centecomm/portal-service';
import { useConversations } from '@centecomm/portal-service-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { conversationsSelectors } from 'State';
import { addErrorMessage, addSuccessMessage } from 'State/GlobalMessages/actionCreators';
import { hasValidRecord } from 'utils';
import styles from './conversation-users-panel.module.css';

interface RemoveUsersPanelProps {
    conversationId: number;
}

function RemoveUsersPanel({ conversationId }: RemoveUsersPanelProps): React.ReactElement<RemoveUsersPanelProps> {
    const { t } = useTranslation(['conversationsFeature']);
    const dispatch = useDispatch();

    const { removeUserFromConversation } = useConversations();

    const participants: ConversationParticipant[] = useSelector(
        conversationsSelectors.participantsForConversation(conversationId),
    );

    const removeUser = (participant: ConversationParticipant) => {
        const { userId, userName } = participant;

        removeUserFromConversation(conversationId, userId)
            .then(() => {
                dispatch(
                    addSuccessMessage(t('conversationsFeature:usersPanel.actions.remove.success', { username: userName })),
                );
            })
            .catch(() => {
                dispatch(
                    addErrorMessage(
                        t('conversationsFeature:usersPanel.actions.remove.errors.withUsername', { username: userName }),
                    ),
                );
            });
    };

    return (
        <div className={styles.ConversationUsersPanel}>
            <h2>{t('conversationsFeature:usersPanel.actions.remove.title')}</h2>
            <ul className={styles.UsersList}>
                {participants
                    .filter((participant: ConversationParticipant) => participant.isActive)
                    .map((participant: ConversationParticipant) => (
                        <li
                            key={`users-panel-${participant.userId}`}
                            className={styles.User}
                            onClick={() => {
                                removeUser(participant);
                            }}
                        >
                            <p className={styles.UserName}>{participant.userName}</p>
                            {hasValidRecord(participant.email) && <p className={styles.UserEmail}>{participant.email}</p>}
                        </li>
                    ))}
            </ul>
        </div>
    );
}

export default RemoveUsersPanel;
